import type { FeatureLike } from 'ol/Feature';
import { Fill, Stroke, Style } from 'ol/style';

import type { FeatureStyleProperties } from '#nora-ui/map/feature-properties';
import { getFeatureProperties } from '#nora-ui/map/feature-properties';
import {
  defaultFillColor,
  defaultLineColor,
  defaultLineWidth,
} from '#nora-ui/map/map/DrawToolUIManager';

export function freehandStyleFunction(feature: FeatureLike): Style {
  const { fillColor, lineColor, lineWidth } = getFeatureProperties<FeatureStyleProperties>(feature);
  return new Style({
    fill: new Fill({
      color: fillColor ?? defaultFillColor,
    }),
    stroke: new Stroke({
      color: lineColor ?? defaultLineColor,
      width: lineWidth ?? defaultLineWidth,
    }),
  });
}
